exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".content__3kFx {\n  display: flex;\n  flex-grow: 1;\n  flex-direction: column;\n  padding: 4%;\n  box-sizing: border-box;\n  font-family: \"Gotham SSm A\", \"Gotham SSm B\", \"Helvetica Neue\", Arial, sans-serif; }\n\n.submit__1rnI {\n  margin: 20px 0; }\n\n.text__23lm {\n  margin-bottom: 20px; }\n", "", {"version":3,"sources":["/app/src/components/login/components/src/components/login/components/TwoFactor.scss","/app/src/components/login/components/src/stylesheets/globals/fonts/index.scss"],"names":[],"mappings":"AAGA;EACE,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,iFCT0E,EDU3E;;AAED;EACE,eAAe,EAChB;;AAED;EACE,oBAAoB,EACrB","file":"TwoFactor.scss","sourcesContent":["@import '~nighthawks';\n@import \"~fonts\";\n\n.content {\n  display: flex;\n  flex-grow: 1;\n  flex-direction: column;\n  padding: 4%;\n  box-sizing: border-box;\n  font-family: $gotham;\n}\n\n.submit {\n  margin: 20px 0;\n}\n\n.text {\n  margin-bottom: 20px;\n}\n","$gotham: 'Gotham SSm A', 'Gotham SSm B', 'Helvetica Neue', Arial, sans-serif;"],"sourceRoot":""}]);

// exports
exports.locals = {
	"content": "content__3kFx",
	"submit": "submit__1rnI",
	"text": "text__23lm"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true,"modules":true,"importLoaders":1,"localIdentName":"[local]__[hash:base64:4]"}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/components/login/components/TwoFactor.scss
// module id = 816
// module chunks = 0